import gql from 'graphql-tag'

export default gql`mutation ycmdContactFavorite($user_id: ID, $facility_id: ID, $custom_contact_id: ID, $mode: FavoriteMode) {
	ycmdContactFavorite(user_id: $user_id, facility_id: $facility_id, custom_contact_id: $custom_contact_id, mode: $mode) {
		status
	}
}`
